import { theme as providedTheme } from 'antd';

export const _colors ={
    purple1: '#722ED1',
    purple2: '#A854FF',
    purple3: '#6058FF',

    blue: '#185CFF',

    white1: '#FFFFFF',
    white2: '#F5F5F5',
    white3: '#F0F2F5',

    grey1: '#d9d9d9', // Светло серый на макете
    grey2: '#8C8C8C',

    black1: '#00000040',
    black2: '#000000E0',
    black3: '#2B3842' // чуть синеватый. На макете кажется, что черный, поэтому и отнес к черным цветам
};

export const getTheme = () => {
    return (
        {
            algorithm: providedTheme.defaultAlgorithm,
            token: {
                colorPrimary: _colors.purple1,
                colorInfo: _colors.purple1,
                fontSize: 14
            },
            components: {
                Typography: {
                    colorPrimary: _colors.black1
                }
            }
        }
    );
}